document.addEventListener("DOMContentLoaded", function () {
    var scrollButtons = document.querySelectorAll(".scroll-btn");

    scrollButtons.forEach(function (button) {
        button.addEventListener("click", function (event) {
            event.preventDefault();

            var targetId = button.getAttribute("href");

            var targetId = button.dataset.target.substring(1);
            var targetElement = document.getElementById(targetId);

            // Scroll to the target element
            targetElement.scrollIntoView({
                behavior: "smooth",
            });

            // Update the URL in the address bar
            history.pushState(null, null, '#' + targetId);
        });
    });

    var faqs = document.querySelectorAll(".faq");

    faqs.forEach((faq)=>{
        faq.addEventListener("click", (e)=>{
            faq.classList.toggle("active");
            $(faq).find('.reponse').slideToggle()
        });
    })
});
